var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('havePriced',{attrs:{"query":{ offerOrNot: 1 },"back":"/havePrice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }